import { render, staticRenderFns } from "./ModalTariffPay.vue?vue&type=template&id=821d0788&scoped=true&"
import script from "./ModalTariffPay.vue?vue&type=script&lang=js&"
export * from "./ModalTariffPay.vue?vue&type=script&lang=js&"
import style0 from "./ModalTariffPay.vue?vue&type=style&index=0&id=821d0788&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821d0788",
  null
  
)

export default component.exports